import { render, staticRenderFns } from "./CreateExamPage.vue?vue&type=template&id=7ccfec9a"
import script from "./CreateExamPage.vue?vue&type=script&lang=js"
export * from "./CreateExamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports